var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExitinline = function SvgExitinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501 501"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 501h388c31 0 56-25 56-56V334h-56v111H57V57h388v111h56V57c0-31-25-56-56-56H57C26 1 1 26 1 57v388c0 31 25 56 56 56m208-389L126 251l139 139 39-39-72-72h269v-56H232l72-71-39-40z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304 152l-39-41-140 140 140 139 39-39-71-72h268v-57H233z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M445 0H57C25 0 0 25 0 57v388c0 31 25 56 57 56h388c31 0 56-25 56-56V333h-57v111H57V57h387v111h57V57c0-32-25-57-56-57z"
  })));
};

export default SvgExitinline;